import moment from 'moment';
import {clientAxios8080} from "../../app/configs/axios";


export const getDisponibilidad = (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/disponibilidad/fisica',
      {
        params: {
          // fechaFin: filters?.fechaFin || '',
          // fechaIni: filters?.fechaIni || '',
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};


export const getAnchoBandaBPS= async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/utilizacion/anchoBanda/bps',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getAnchoBandaMBPS= async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/utilizacion/anchoBanda/mbps',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getAnchoBanda = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/utilizacion/anchoBanda',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getCPU = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/utilizacion/cpu',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};


export const getDisponibilidadPromedio = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/disponibilidad/wan',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getComparativo = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/comparativo/anchoBanda',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getInmuebles = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/inmuebles/administrados/proveedor',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getDispositivos = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/dispositivos/desplegados',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTopMaxAB = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/indicadores/getTopMayorConsumoAnchoBanda',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getTopMinAB = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.get('/ms-reportes/reportes/indicadores/getTopMenorConsumoAnchoBanda',
      {
        params: {
          fechaIni: filters?.initDateSelected
            ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
          fechaFin: filters?.endDateSelected
            ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
            : moment().format('Y-MM-DD HH:mm:00'),
        },
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getLatency = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.post('/ms-reportes/reportes/metricas/latency-losspackage',
      {
        fechaIni: filters?.initDateSelected
          ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
          : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
        fechaFin: filters?.endDateSelected
          ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
          : moment().format('Y-MM-DD HH:mm:00'),
          searchByMetrica: "1"
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

export const getLossPackage = async (filters) => {
  return new Promise((resolve, reject) => {
    clientAxios8080.post('/ms-reportes/reportes/metricas/latency-losspackage',
      {
        fechaIni: filters?.initDateSelected
          ? moment(filters?.initDateSelected).format('Y-MM-DD HH:mm:00')
          : moment().subtract(1, 'hour').format('Y-MM-DD HH:mm:00'),
        fechaFin: filters?.endDateSelected
          ? moment(filters?.endDateSelected).format('Y-MM-DD HH:mm:00')
          : moment().format('Y-MM-DD HH:mm:00'),
          searchByMetrica: "2"
        // signal: AbortSignal.timeout(10000),
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};